import { render, staticRenderFns } from "./CardNewsMain.vue?vue&type=template&id=7cc30da8&scoped=true"
import script from "./CardNewsMain.vue?vue&type=script&lang=js"
export * from "./CardNewsMain.vue?vue&type=script&lang=js"
import style1 from "./CardNewsMain.vue?vue&type=style&index=1&id=7cc30da8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc30da8",
  null
  
)

export default component.exports